import styled from 'styled-components';
import { media } from '~constants/media';

export const HeadingText = styled.div`
  font-weight: 300;
  font-size: 18px;
  line-height: 20px;

  ${media.md`
    font-size: 23px;
    line-height: 25px;
  `}
`;

export const ActionText = styled.div`
  margin-top: 10px;
  font-weight: 300;
  font-size: 15px;
  line-height: 17px;

  ${media.md`
    font-size: 16px;
    line-height: 18px;
  `}
`;
